export const CONTRACT_TYPE = {
  DELETE: 'delete',
  DETAILS: 'details',
};
